import { api } from 'shared/api'
import { smsApiSchemas } from 'shared/api/requests/sms/schemas'

export const smsApi = {
  getData: api.account.createGet({
    url: '/sms/getData',
    schemas: smsApiSchemas.getData,
  }),
}
